var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.certainComponent,{tag:"component",class:{
        'ui-action-btn': true,
        '--dark': _vm.isDarkTheme,
        '--transparent': _vm.isTransparentTheme,
        '--transparent-light': _vm.isTransparentLightTheme,
        '--light': _vm.isLightTheme,
        '--only-text': _vm.isTypeText,
        '--only-icon': _vm.isTypeIcon,
        '--transparent-border': _vm.isTransparentBorderTheme,
        '--size-medium': _vm.isSizeMedium,
        '--size-small': _vm.isSizeSmall,
        '--size-tiny': _vm.isSizeTiny,
        '--fit-content': !_vm.isFreeWidth,
        disabled: _vm.disabled
    },attrs:{"to":_vm.isLink ? _vm.urlPath : null,"href":_vm.isLink ? _vm.urlPath : null,"type":_vm.btnType,"disabled":_vm.disabled,"title":_vm.isLink ? _vm.urlPath : _vm.btnText},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{class:{ 'ui-action-btn__container': true, '--reverse': _vm.isReversContent }},[_vm._t("default"),_vm._v(" "),(_vm.isTypeText || _vm.isDefaultType)?_c('div',{staticClass:"ui-action-btn__container__text"},[_c('span',[_vm._v(_vm._s(_vm.btnText))])]):_vm._e(),_vm._v(" "),(_vm.isTypeIcon || _vm.isDefaultType)?_c('div',{staticClass:"ui-action-btn__container__icon"},[_c('svg',[_c('use',{attrs:{"xlink:href":_vm.iconLink}})])]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }